<template>
  <div id="container">
    <div class="navbar">
      <div class="nav_wrapper margin">
        <h4 class="title">纠纷处理</h4>
      </div>
    </div>
    <div class="argeement">
      <p class="title1">纠纷处理</p>
    　<p>北京棋开德胜科技有限公司营运的大唐互娱（北京）网站平台（以下称“大唐互娱（北京）”）在此特别提醒用户在注册、登录本网站平台游戏前请务必仔细阅读本《纠纷处理》及 《大唐互娱（北京）用户使用协议》（未成年人应当在其法定监护人陪同下阅读）中的各个条款，以确保您在享受本网站平台游戏服务的同时维护自身合法权益：</p>
      <p>一、用户之间纠纷处理方式</p>
      <p>1．大唐互娱（北京）仅作为本网站平台游戏的运营商，如若本网站平台游戏用户之间发生纠纷且无法协商一致的，可向国家相关行政机关或司法机关寻求解决包括但不限于向公安机 关报案、申请仲裁或向人民法院提起诉讼等。大唐互娱（北京）将会为实名注册用户提供必要的协助和支持，并根据有关行政机关和司法机关的要求承担一定的举证责任或采取必要措施。</p>
      <p>2．本网站平台游戏用户之间发生纠纷的，也可向大唐互娱（北京）的客服人员投诉并举证。用户需提供与其账号注册信息一致的个人有效身份证件、必要的国家行政或司法机关文件和其他大唐互娱（北京）要求提供的相关证据。经大唐互娱（北京）审核确认后，可以给予必要的协助和支持。</p>
      <p>二、用户与大唐互娱（北京）之间纠纷处理方式</p>
      <p>1．如本网站平台游戏用户对大唐互娱（北京）的服务有任何异议的，可以向大唐互娱（北京）的客服人员投诉并举证。查证属实的，大唐互娱（北京）将立即更正并按照现行法律规定给予用户必要的补偿。</p>
      <p>本条款最终解释权归北京棋开德胜科技有限公司所有</p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isLogin:false
      }
    },
    components:{
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../components/style/mixin';
  .navbar{
    position: relative;
    width: 100%;
    min-width: 1000px;
    height:75px;
    color: #fff;
    background-color:#303030;
    margin-top: -5px;
    .nav_wrapper{
      position:relative;
      height:100%;
      background: url('../../images/navbar.png') no-repeat center center;
      .title{
        position:relative;
        padding:20px 0px 20px 20px;
        font-weight:bolder;
        font-size:26px;
        color:#fff;
      }
      .title:before{
        position: absolute;
        top: 26px;
        left:0px;
        bottom: 1px;
        display: inline-block;
        content: '';
        height:24px;
        content:'';
        border-left:4px solid #ffdb17;
        margin-right:28px;
      }
    }
  }
  .argeement{padding: 30px  300px}
  .argeement p{margin-top: 10px}
  .title1{font-size: 26px;font-weight: bold}
  .title2{font-weight: bold;font-size: 20px}
  #container {margin-bottom: 200px}
</style>
